import store from "../store";

import { BUSINESSANALYTICS_UPDATE } from "../store/slices";
import { DatabaseInstance } from "./databaseClass";

class BusinessAnalyticsClass {
  constructor() {}
  public initialize = async () => {
    try {
      await this.setBusinessAnalytics();
    } catch (error) {
      console.error("Error initializing businessAnalytics", error);
      throw error;
    }
  };
  private getBusinessAnalytics = async (id: string, businessType: string) => {
    //have this handle getting checkin data if businesstype is venue
    //maybe have it be a secondary object
    let favoritesEndpoint = "business-analytics/favorite-data";
    let checkInEndpoint = "business-analytics/check-in-data";
    let checkInHistoryEndpoint = "business-analytics/check-in-history-data";
    let followerGainHistoryEndpoint = "business-analytics/follower-gain-history-data";
    let headers = {
      actingasid: id,
      actingastype: businessType,
    };
    //followers
    const data = {
      endpoint: favoritesEndpoint,
      headers,
    };
    //checkins
    const data2 = {
      endpoint: checkInEndpoint,
      headers,
    };
    //check in history for past 7 days
    const data3 = {
      endpoint: checkInHistoryEndpoint,
      headers,
    };
    //follower gains history for past 7 days
    const data4 = {
      endpoint: followerGainHistoryEndpoint,
      headers,
    };

    const data5 = {
      endpoint: `friends/get-count?id=${id}&type=${businessType}`,
    };
    let checkinRes;
    //currently checkinHistory is not sorted between followers vs checkins
    //consider updating backend to return array for follower checkins as well.
    let checkinHistoryRes;
    let followerGainHistoryRes;
    let followerCountRes;
    let returnBlob;

    const res = await DatabaseInstance.getRecord(data);

    followerGainHistoryRes = await DatabaseInstance.getRecord(data4);
    followerCountRes = await DatabaseInstance.getRecord(data5);

    console.log("follower gain history res", followerGainHistoryRes);
    if (businessType === "venue") {
      checkinRes = await DatabaseInstance.getRecord(data2);
      checkinHistoryRes = await DatabaseInstance.getRecord(data3);
      returnBlob = {
        favoriteData: res,
        checkinData: checkinRes,
        checkinHistoryData: checkinHistoryRes,
        followerGainHistoryData: followerGainHistoryRes,
        favoriteCount: followerCountRes.followCount,
      };
      return returnBlob;
    }
    return {
      favoriteData: res,
      followerGainHistoryData: followerGainHistoryRes,
      favoriteCount: followerCountRes,
    };
  };
  public setBusinessAnalytics = async () => {
    //use business class to get active business id and active business type
    //there isn't a public method for it, so just getting from localstorage
    const activeBusinessString = localStorage.getItem("activeBusiness");
    let activeBusiness;
    if (!activeBusinessString) {
      return; //TODO: RETURN USER TO BUSINESS SELECTION MAYBE
    }
    activeBusiness = JSON.parse(activeBusinessString);
    const res = await this.getBusinessAnalytics(activeBusiness.businessId, activeBusiness.businessType);

    store.dispatch(
      BUSINESSANALYTICS_UPDATE({
        data: {
          ...store.getState().businessAnalytics,
          activeBusinessAnalytics: res, //maybe destructure it, nope destructure later based on venue or brand
          businessType: activeBusiness.businessType,
        },
      }),
    );
    return;
  };

  public getUserLocationAnalytics = async (zipCodes: string[], id: number, businessType: string) => {
    let headers = {
      actingasid: id,
      actingastype: businessType,
    };
    const params = {
      endpoint: `business-analytics/location-user-analytics?zipCodes=${zipCodes.join(",")}`,
      headers,
    };

    const res = await DatabaseInstance.getRecord(params);

    console.log("res", res);
    return res;
  };
}

const BusinessAnalyticsInstance = new BusinessAnalyticsClass();
export { BusinessAnalyticsInstance };
